// This address points to a dummy ERC20 contract deployed on Ethereum Mainnet,
// Goerli, Kovan, Rinkeby and Ropsten. Replace it with your smart contracts.
const addresses = {
  tttNetwork: '0x3EA2a1fED7FdEf300DA19E97092Ce8FdF8bf66A3',
  tttErc20: '0x59105441977ecD9d805A4f5b060E34676F50F806',
  tokenNetworkLocal: '0xe97DbD7116D168190F8A6E7beB1092c103c53a12',
  erc20Local: '0xA57B8a5584442B467b4689F1144D269d096A3daF',
  secretRegistryLocal: '0x5b1869D9A4C187F2EAa108f3062412ecf0526b24'
}

export default addresses
